import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const FlashIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
    {...props}
  >
    <Path
      d="M16.91 10.396a.545.545 0 0 0-.465-.27h-3.89V3.593a.586.586 0 0 0-.44-.58.545.545 0 0 0-.623.339L7.048 14.04a.628.628 0 0 0 .042.564c.102.169.278.271.466.271h3.888v6.531c0 .28.184.523.44.58A.557.557 0 0 0 12 22a.555.555 0 0 0 .508-.353l4.444-10.687a.627.627 0 0 0-.042-.564Z"
      fill={color}
    />
  </Svg>
);

export default FlashIcon;
